// Payment Setup (Seller) — the guided payout-account onboarding for a seller.
// All the UI lives in the shared PayeePaymentSetupPanel; this tab just wires in
// the seller's api module.

import { PayeePaymentSetupPanel } from "../components/PayeePaymentSetupPanel";
import { sellerPaymentSetupApi } from "../api/paymentSetup";

export function SellerPaymentSetupTab() {
  return <PayeePaymentSetupPanel api={sellerPaymentSetupApi} />;
}
